import { registry } from '@generated/registry'
import { createTuyau } from '@tuyau/core/client'

export const client = createTuyau({
  baseUrl: '/',
  registry,
  headers: { Accept: 'application/json' },
  credentials: 'include',
})

export const urlFor = client.urlFor
